module.exports = __webpack_public_path__ + "img/3.6d73f08e.jpg";